import { Report1910Container } from "../../../containers/borrowSystem/Report/Report1910Container";

export function Report1910Page() {
    return (
        <Report1910Container />
    )
}